<template>
  <div class="popchecBox">
    <el-tooltip class="item" effect="dark" :open-delay="300" v-if="tooltipShow()" :content="content" placement="top">
      <el-checkbox v-model="checked" :disabled="disabled" @change="clickCheckbox">
        {{ renderText() }}
      </el-checkbox>
    </el-tooltip>
    <el-checkbox v-model="checked" v-if="checboxShow()" @change="clickCheckbox">
      {{ renderText() }}
    </el-checkbox>

    <img class="select_icon" v-if="selectRender()" :src="require('@/assets/img/icon_select.png')" alt="" />
    <img class="unselect" v-if="unselectRender()" :src="require('@/assets/img/icon_unselect.png')" alt="" />
  </div>
</template>
<script>
export default {
  // data 为scope type 1 远程审方药师 2 驻店 3 人脸 7-三方审方中心 8 图文问诊开关
  // listData scope
  props: ['isHead', 'listData', 'type'],
  watch: {
    mode() {
      this.renderRes();
    },
    getchangeSetingList() {
      this.StatusChange();
    }
  },
  mounted() {
    // 渲染默认模式情况
    const { type, listData, mode, getchangeSetingList } = this;

    let {
      remotePharmacistStatus,
      storePharmacistStatus,
      faceStatus,
      id,
      remotePharmacist,
      drugstorePharmacist,
      dispenseStatus,
      dispatchStatus,
      diagnoseBeforeAskStatus,
      localPrescriptionsCenter = '',
      localPrescriptions,
      userPicStatus
    } = listData.row;

    this.renderDisabled();
    // 如果修改列表中存在修改数据
    let res = getchangeSetingList.filter(v => {
      if (v.id == id) {
        return v;
      }
    })[0];
    if (res) {
      // 如果已存在该数据
      let { FEremote, FEpha, FEface, FEdispenseStatus, FEdispatchStatus, FEDiagnoseBeforeAskStatus, FEUserPicStatus } =
        res;
      if (type && type == 1) {
        this.checked = FEremote == 1;
        // if (FEremote == 1) {
        //   this.checked = true;
        // } else {
        //   this.checked = false;
        // }
      }
      if (type && type == 2) {
        this.checked = FEpha == 1;
      }
      if (type && type == 3) {
        this.checked = FEface == 1;
      }
      if (type && type == 3) {
        if (drugstorePharmacist.length == 0 && remotePharmacist.length == 0) {
          this.disabled = true;
          this.content = '该药店未开启远程药师审方或驻店药师审方设置，请先设置';
        } else {
          this.disabled = false;
        }
      }
      if (type && type == 4) {
        this.checked = FEdispenseStatus == 1;
      }
      if (type && type == 5) {
        this.checked = FEdispatchStatus == 1;
      }
      if (type && type == 6) {
        this.checked = FEDiagnoseBeforeAskStatus == 1;
      }
      if (type && type == 7) {
        this.checked = localPrescriptionsCenter.length > 0;
      }

      if (type && type == 8) {
        this.checked = FEUserPicStatus == 1;
      }
    } else {
      // 如果不存在修改 根据相关状态渲染
      if (type && type == 1 && remotePharmacistStatus == 1) {
        if (remotePharmacist.length == 0) {
          // 远程审方药师不存在

          this.disabled = true;
          return;
        }
        this.checked = true;
      }
      if (type && type == 2 && storePharmacistStatus == 1) {
        if (drugstorePharmacist.length == 0) {
          // 驻店审方药师不存在
          this.checked = false;
          return;
        }
        this.checked = true;
      }
      if (type && type == 3 && faceStatus == 1) {
        this.checked = true;
      }

      if (type && type == 4 && dispenseStatus == 1) {
        this.checked = true;
      }

      if (type && type == 5 && dispatchStatus == 1) {
        this.checked = true;
      }
      if (type && type == 6 && diagnoseBeforeAskStatus == 1) {
        this.checked = true;
      }
      if (type && type == 7 && localPrescriptionsCenter.length) {
        this.checked = true;
      }
      if (type && type == 8 && userPicStatus == 1) {
        this.checked = true;
      }
      // if (type && type == 3) {
      //   if (drugstorePharmacist.length == 0 && remotePharmacist.length == 0) {
      //     this.disabled = true;
      //     this.content = '该药店未开启远程药师审方或驻店药师审方设置，请先设置';
      //   } else {
      //     this.disabled = false;
      //   }
      // }
    }
  },
  data() {
    return {
      checked: false,
      disabled: false,
      content: ''
    };
  },
  computed: {
    mode() {
      return this.$store.getters.getShopManagementMode;
    },
    getchangeSetingList() {
      return this.$store.getters.getchangeSetingList;
    }
  },
  methods: {
    tooltipShow() {
      // 带提示框的checkbox显示逻辑
      if (this.mode == 2) {
        if (this.disabled) {
          return true;
        }
      }
    },
    renderDisabled() {
      // 渲染禁用情况
      const { type, listData, mode, getchangeSetingList } = this;
      let {
        disableStatus,
        remotePharmacistStatus,
        storePharmacistStatus,
        faceStatus,
        id,
        remotePharmacist,
        drugstorePharmacist,
        diagnoseBeforeAskStatus
      } = listData.row;

      if (type == 1) {
        if (remotePharmacist.length == 0) {
          // 远程审方药师不存在

          this.disabled = true;
          this.checked = false;
          this.content = '无远程审方药师，无法启用该审方模式';
        }
      } else if (type == 2) {
        if (drugstorePharmacist.length == 0) {
          // 驻店审方药师不存在
          this.checked = false;
          this.content = '无驻店审方药师，无法启用该审方模式';
          this.disabled = true;
        }
      }
      this.disableStatusRender(disableStatus);
    },
    disableStatusRender(disableStatus) {
      if (disableStatus == 1) {
        // 该门店被禁用
        this.disabled = true;
        this.content = '该门店被禁用';
      }
    },
    renderRes() {
      // 渲染编辑模式数据 getchangeSetingList
      this.StatusChange();
      // console.log('模式切换');
    },
    StatusChange() {
      // 监听到全局数据变化了
      const { type, listData, mode, getchangeSetingList } = this;

      let {
        remotePharmacistStatus,
        storePharmacistStatus,
        faceStatus,
        id,
        disableStatus,
        dispenseStatus,
        dispatchStatus,
        drugstorePharmacist,
        remotePharmacist,
        diagnoseBeforeAskStatus,
        localPrescriptionsCenter = '',
        userPicStatus
      } = listData.row;
      let res = getchangeSetingList.filter(v => {
        if (v.id == id) {
          return v;
        }
      })[0];
      if (res) {
        // 如果已存在该数据
        let {
          FEremote,
          FEpha,
          FEface,
          FEdispatchStatus,
          FEdispenseStatus,
          FEDiagnoseBeforeAskStatus,
          FElpcStatus,
          FEUserPicStatus
        } = res;
        if (type && type == 1) {
          this.checked = FEremote == 1;
          // if (FEremote == 1) {
          //   this.checked = true;
          // } else {
          //   this.checked = false;
          // }
          return;
        }
        if (type && type == 2) {
          this.checked = FEpha == 1;
          // if (FEpha == 1) {
          //   this.checked = true;
          // } else {
          //   this.checked = false;
          // }
          return;
        }
        if (type && type == 3) {
          this.checked = FEface == 1;

          // if (FEface == 1) {
          //   this.checked = true;
          // } else {
          //   this.checked = false;
          // }
        }
        if (type && type == 4) {
          this.checked = FEdispenseStatus == 1;
        }
        if (type && type == 5) {
          this.checked = FEdispatchStatus == 1;
        }
        if (type && type == 6) {
          this.checked = FEDiagnoseBeforeAskStatus == 1;
        }
        if (type && type == 7) {
          this.checked = FElpcStatus == 1;
        }
        if (type && type == 8) {
          this.checked = FEUserPicStatus == 1;
        }
      } else {
        // 状态改变重新渲染已选
        this.disableStatusRender(disableStatus);
        if (type && type == 1) {
          this.checked = remotePharmacistStatus == 1;
          // if (remotePharmacistStatus == 1) {
          //   this.checked = true;
          // } else {
          //   this.checked = false;
          // }
          return;
        }
        if (type && type == 2) {
          this.checked = storePharmacistStatus == 1;
          // if (storePharmacistStatus == 1) {
          //   this.checked = true;
          // } else {
          //   this.checked = false;
          // }
          return;
        }
        if (type && type == 3) {
          this.checked = faceStatus == 1;
          // if (type && type == 3) {
          // if (faceStatus == 1) {
          //   this.checked = true;
          // } else {
          //   this.checked = false;
          // }
        }
        if (type && type == 4) {
          this.checked = dispenseStatus == 1;
        }
        if (type && type == 5) {
          this.checked = dispatchStatus == 1;
        }
        if (type && type == 6) {
          this.checked = diagnoseBeforeAskStatus == 1;
        }
        if (type && type == 7) {
          this.checked = localPrescriptionsCenter.length > 0;
        }
        if (type && type == 8) {
          this.checked = userPicStatus == 1;
        }
      }
    },
    clickCheckbox() {
      // 优化代码
      // 获取数据
      const { type, listData, mode, getchangeSetingList } = this;
      let {
        remotePharmacistStatus,
        storePharmacistStatus,
        faceStatus,
        id,
        name,
        dispenseStatus,
        dispatchStatus,
        diagnoseBeforeAskStatus,
        localPrescriptionsCenter = '',
        userPicStatus,
        localPrescriptions
      } = listData.row;
      // 默认认为修改列表中没有当前数据
      let FEremote = remotePharmacistStatus;
      let FEpha = storePharmacistStatus;
      let FEface = faceStatus;
      let FElpcStatus = Number(Boolean(localPrescriptionsCenter)); // 三方审方中心有id
      // 修复历史数据不存在时，设置初值
      let FEdispenseStatus = dispenseStatus || 0;
      let FEdispatchStatus = dispatchStatus || 0;
      let FEDiagnoseBeforeAskStatus = diagnoseBeforeAskStatus || 0;
      let FEUserPicStatus = userPicStatus || 0;
      let res = getchangeSetingList.filter(v => {
        if (v.id == id) {
          // 数据存在
          return v;
        }
      })[0];
      if (res) {
        FEremote = res.FEremote;
        FEpha = res.FEpha;
        FEface = res.FEface;
        FEdispenseStatus = res.FEdispenseStatus;
        FEdispatchStatus = res.FEdispatchStatus;
        FEDiagnoseBeforeAskStatus = res.FEDiagnoseBeforeAskStatus;
        FElpcStatus = res.FElpcStatus;
        FEUserPicStatus = res.FEUserPicStatus;
      }
      if (type == 1) {
        FEremote = this.genValue(type, FEpha, FEface, FEremote);
      }
      if (type == 2) {
        FEpha = this.genValue(type, FEpha, FEface, FEremote);
      }
      if (type == 3) {
        FEface = this.genValue(type, FEpha, FEface, FEremote);
      }
      if (type == 4) {
        FEdispenseStatus = this.genValue(type);
      }
      if (type == 5) {
        FEdispatchStatus = this.genValue(type);
      }
      if (type == 6) {
        FEDiagnoseBeforeAskStatus = this.genValue(type);
      }
      if (type == 7) {
        FElpcStatus = this.genValue(type);
      }
      if (type == 8) {
        FEUserPicStatus = this.genValue(type);
      }
      if (
        FEremote == 'error' ||
        FEpha == 'error' ||
        FEface == 'error' ||
        FEdispenseStatus == 'error' ||
        FEdispatchStatus == 'error' ||
        FEDiagnoseBeforeAskStatus == 'error' ||
        FElpcStatus == 'error' ||
        FEUserPicStatus == 'error'
      ) {
        return;
      }
      this.$store.dispatch('shopManagement/UPDATESETINGLIST', {
        ...listData.row,
        FEremote,
        FEpha,
        FEface,
        FEdispenseStatus,
        FEdispatchStatus,
        FEDiagnoseBeforeAskStatus,
        FElpcStatus,
        FEUserPicStatus
      });
    },
    genValue(type, FEpha, FEface, FEremote, FEdispenseStatus, FEdispatchStatus) {
      // 生成需要的值
      if (type && type == 1) {
        if (FEface == 1 && FEpha == 0) {
          // 如果关闭了远程审方 同时人脸识别是打开状态 药店审方也关闭
          this.checked = true;
          this.$message.error('该店已开启人脸识别功能，请开启驻店药师审方或先关闭人脸识别设置');
          return 'error';
          // 阻止提交
        }
        return String(Number(this.checked));
      }
      if (type && type == 2) {
        if (FEface == 1 && FEremote == 0) {
          // 如果关闭了药店审方 同时人脸识别是打开状态 同时远程审方关闭
          this.checked = true;
          this.$message.error(`您选择的${name}店已开启人脸识别功能，请开启远程药师审方或先关闭人脸识别设置`);
          // 阻止提交
          return 'error';
        }
        return String(Number(this.checked));
      }
      if (type && type == 3) {
        FEface = Number(this.checked);

        if (FEpha == 0 && FEremote == 0) {
          // 禁止打开
          this.checked = false;
          this.$message.error(`该药店未开启远程药师审方或驻店药师审方设置，请先设置`);
          // 阻止提交
          return 'error';
        }
        return String(Number(this.checked));
      }
      return String(Number(this.checked));
    },
    Cchange(cbvalue) {
      // 状态变更
      const { type, listData, mode, getchangeSetingList } = this;
      let { remotePharmacistStatus, storePharmacistStatus, faceStatus, id, name, diagnoseBeforeAskStatus } =
        listData.row;
      let res = getchangeSetingList.filter(v => {
        if (v.id == id) {
          return v;
        }
      })[0];

      if (res) {
        // 如果已存在该数据
        let { FEremote, FEpha, FEface, FEDiagnoseBeforeAskStatus } = res;
        if (type && type == 1) {
          FEremote = Number(this.checked);
          if (FEface == 1 && FEpha == 0) {
            // 如果关闭了远程审方 同时人脸识别是打开状态 药店审方也关闭
            this.checked = true;
            this.$message.error('该店已开启人脸识别功能，请开启驻店药师审方或先关闭人脸识别设置');
            // 阻止提交
            return;
          }
        }
        if (type && type == 2) {
          FEpha = Number(this.checked);
          if (FEface == 1 && FEremote == 0) {
            // 如果关闭了药店审方 同时人脸识别是打开状态 同时远程审方关闭
            this.checked = true;
            this.$message.error(`您选择的${name}店已开启人脸识别功能，请开启远程药师审方或先关闭人脸识别设置`);
            // 阻止提交
            return;
          }
        }
        if (type && type == 3) {
          FEface = Number(this.checked);

          if (FEpha == 0 && FEremote == 0) {
            // 禁止打开
            this.checked = false;
            this.$message.error(`该药店未开启远程药师审方或驻店药师审方设置，请先设置`);
            // 阻止提交
            return;
          }
        }

        if (type && type == 6) {
          FEDiagnoseBeforeAskStatus = Number(this.checked);
        }

        this.$store.dispatch('shopManagement/UPDATESETINGLIST', {
          ...listData.row,
          FEremote,
          FEpha,
          FEface,
          FEDiagnoseBeforeAskStatus
        });
      } else {
        // 数据不存在
        let FEremote = null || remotePharmacistStatus;
        let FEpha = null || storePharmacistStatus;
        let FEface = null || faceStatus;
        let FEDiagnoseBeforeAskStatus = null || diagnoseBeforeAskStatus;
        if (type && type == 1) {
          FEremote = Number(this.checked);

          if (FEface == 1 && FEpha == 0) {
            // 如果关闭了远程审方 同时人脸识别是打开状态 药店审方同时也是关闭
            this.checked = true;
            this.$message.error('该店已开启人脸识别功能，请开启驻店药师审方或先关闭人脸识别设置');
            // 阻止提交
            return;
          }
        }
        if (type && type == 2) {
          FEpha = Number(this.checked);

          if (FEface == 1 && FEremote == 0) {
            // 如果关闭了药店审方 同时人脸识别是打开状态 同时远程审方也关闭
            this.checked = true;
            this.$message.error(`您选择的${name}店已开启人脸识别功能，请开启远程药师审方或先关闭人脸识别设置`);
            // 阻止提交
            return;
          }
        }
        if (type && type == 3) {
          FEface = Number(this.checked);
          console.log(FEpha, FEremote, 'FEremote');

          if (FEpha == 0 && FEremote == 0) {
            // 禁止打开
            this.checked = false;
            this.$message.error(`该药店未开启远程药师审方或驻店药师审方设置，请先设置`);
            // 阻止提交
            return;
          }
        }

        if (type && type == 6) {
          FEDiagnoseBeforeAskStatus = Number(this.checked);
        }

        this.$store.dispatch('shopManagement/UPDATESETINGLIST', {
          ...listData.row,
          FEremote,
          FEpha,
          FEface,
          FEDiagnoseBeforeAskStatus
        });
      }
    },
    renderText() {
      return '开启';
    },
    selectRender() {
      const { type, listData, mode } = this;

      let {
        remotePharmacistStatus,
        storePharmacistStatus,
        faceStatus,
        dispenseStatus,
        dispatchStatus,
        diagnoseBeforeAskStatus,
        localPrescriptionsCenter = '',
        userPicStatus
      } = listData.row;

      if (this.mode == 2) {
        return false;
      }

      if (type == 1) {
        if (remotePharmacistStatus != 0) {
          // 渲染远程审方药师
          return true;
        }
      }
      if (type == 2) {
        if (storePharmacistStatus != 0) {
          // 渲染驻店
          return true;
        }
      }
      if (type == 3) {
        if (faceStatus != 0) {
          // 渲染人脸
          return true;
        }
      }
      if (type == 4) {
        if (dispenseStatus && dispenseStatus != 0) {
          return true;
        }
      }
      if (type == 5) {
        if (dispatchStatus && dispatchStatus != 0) {
          return true;
        }
      }
      if (type == 6) {
        if (diagnoseBeforeAskStatus && diagnoseBeforeAskStatus != 0) {
          return true;
        }
      }
      if (type == 7) {
        if (localPrescriptionsCenter.length) {
          return true;
        }
      }

      if (type == 8) {
        if (userPicStatus && userPicStatus == 1) {
          return true;
        }
      }
    },
    unselectRender() {
      const { type, listData, mode } = this;

      let {
        remotePharmacistStatus,
        storePharmacistStatus,
        faceStatus,
        dispenseStatus,
        dispatchStatus,
        diagnoseBeforeAskStatus,
        localPrescriptionsCenter,
        userPicStatus
      } = listData.row;

      if (mode == 2) {
        return false;
      }
      if (type == 1) {
        if (remotePharmacistStatus == 0) {
          // 渲染远程审方药师
          return true;
        }
      }
      if (type == 2) {
        if (storePharmacistStatus == 0) {
          // 渲染驻店
          return true;
        }
      }
      if (type == 3) {
        if (faceStatus == 0) {
          // 渲染人脸识别
          return true;
        }
      }
      if (type == 4) {
        if (dispenseStatus == 0 || !dispenseStatus) {
          return true;
        }
      }
      if (type == 5) {
        if (dispatchStatus == 0 || !dispatchStatus) {
          return true;
        }
      }
      if (type == 6) {
        if (diagnoseBeforeAskStatus == 0 && !diagnoseBeforeAskStatus) {
          return true;
        }
      }
      if (type == 7) {
        if (!localPrescriptionsCenter) {
          return true;
        }
      }

      if (type == 8) {
        if (userPicStatus != 1) {
          return true;
        }
      }
    },
    checboxShow() {
      // 显示checkbox 逻辑
      if (this.mode == 2) {
        if (this.disabled) {
          return false;
        }
        return true;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.popchecBox {
  float: left;
  line-height: normal;
  padding: 0;
  .base {
    width: 14px;
    display: block;
    margin-left: 18px;
  }
  .unselect {
    @extend .base;
  }
  .select_icon {
    @extend .base;
  }
}
</style>
